'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Badge, Button, Checkbox, Dialog, Loader } from '@/shared/components/ui';
import { feriadosService } from '@/features/feriados/services/feriadosService';
import { type FeriadoNacionalPreview } from '@/features/feriados/types/feriadosTypes';
interface ImportarNacionaisDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ano: number;
  salvando: boolean;
  onImportar: (datas: string[]) => Promise<boolean>;
}
function formatarDataBR(iso: string): string {
  const [ano, mes, dia] = iso.split('-');
  if (!ano || !mes || !dia) return iso;
  return `${dia}/${mes}/${ano}`;
}
export function ImportarNacionaisDialog(t0) {
  const $ = _c(52);
  const {
    open,
    onOpenChange,
    ano,
    salvando,
    onImportar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [itens, setItens] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Set();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [selecionados, setSelecionados] = useState(t2);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);
  let t3;
  let t4;
  if ($[2] !== ano || $[3] !== open) {
    t3 = () => {
      if (!open) {
        return;
      }
      setCarregando(true);
      setErro(null);
      feriadosService.previewNacionais(ano).then(lista => {
        setItens(lista);
        setSelecionados(new Set(lista.filter(_temp).map(_temp2)));
        setCarregando(false);
      }).catch(error => {
        setErro(error instanceof Error ? error.message : "N\xE3o foi poss\xEDvel calcular os feriados.");
        setCarregando(false);
      });
    };
    t4 = [open, ano];
    $[2] = ano;
    $[3] = open;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (data, checked) => {
      setSelecionados(atual => {
        const proximo = new Set(atual);
        if (checked) {
          proximo.add(data);
        } else {
          proximo.delete(data);
        }
        return proximo;
      });
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const alternar = t5;
  let t6;
  if ($[7] !== itens) {
    t6 = itens.filter(_temp3);
    $[7] = itens;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const totalImportavel = t6.length;
  let t7;
  if ($[9] !== onImportar || $[10] !== onOpenChange || $[11] !== selecionados) {
    t7 = async () => {
      const ok = await onImportar([...selecionados]);
      if (ok) {
        onOpenChange(false);
      }
    };
    $[9] = onImportar;
    $[10] = onOpenChange;
    $[11] = selecionados;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleImportar = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-heading-3 font-heading-3 text-default-font">Importar feriados nacionais</span>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== ano) {
    t9 = <div className="flex flex-col">{t8}<span className="text-caption font-caption text-subtext-color">Fixos e móveis de {ano} (Carnaval, Sexta-Santa, Corpus Christi etc.), calculados automaticamente.</span></div>;
    $[14] = ano;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== ano || $[17] !== carregando || $[18] !== erro || $[19] !== itens || $[20] !== salvando || $[21] !== selecionados || $[22] !== totalImportavel) {
    t10 = carregando ? <div className="flex h-32 items-center justify-center"><Loader /></div> : erro ? <span className="text-caption font-caption text-error-700">{erro}</span> : itens.length === 0 ? <span className="text-body font-body text-subtext-color">Nenhum feriado nacional encontrado para {ano}.</span> : <>{totalImportavel === 0 ? <span className="text-caption font-caption text-subtext-color">Todos os feriados nacionais de {ano} já estão importados.</span> : null}<div className="flex max-h-80 flex-col gap-1 overflow-y-auto">{itens.map(item_2 => <div key={item_2.data} className="flex items-center justify-between gap-3 rounded-md px-2 py-1.5 odd:bg-neutral-50"><Checkbox label={`${item_2.nome} — ${formatarDataBR(item_2.data)}`} checked={selecionados.has(item_2.data)} disabled={item_2.jaExiste || salvando} onCheckedChange={checked_0 => alternar(item_2.data, checked_0)} />{item_2.jaExiste ? <Badge variant="neutral">Já existe</Badge> : null}</div>)}</div></>;
    $[16] = ano;
    $[17] = carregando;
    $[18] = erro;
    $[19] = itens;
    $[20] = salvando;
    $[21] = selecionados;
    $[22] = totalImportavel;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = selecionados.size === 1 ? "" : "s";
  let t12;
  if ($[24] !== selecionados.size || $[25] !== t11) {
    t12 = <span className="text-caption font-caption text-subtext-color">{selecionados.size} selecionado{t11}</span>;
    $[24] = selecionados.size;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== onOpenChange) {
    t13 = () => onOpenChange(false);
    $[27] = onOpenChange;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== salvando || $[30] !== t13) {
    t14 = <Button variant="neutral-secondary" onClick={t13} disabled={salvando}>Cancelar</Button>;
    $[29] = salvando;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = salvando || selecionados.size === 0;
  let t16;
  if ($[32] !== handleImportar) {
    t16 = () => void handleImportar();
    $[32] = handleImportar;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== salvando || $[35] !== t15 || $[36] !== t16) {
    t17 = <Button variant="brand-primary" loading={salvando} disabled={t15} onClick={t16}>Importar</Button>;
    $[34] = salvando;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t14 || $[39] !== t17) {
    t18 = <div className="flex gap-2">{t14}{t17}</div>;
    $[38] = t14;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t12 || $[42] !== t18) {
    t19 = <div className="flex items-center justify-between">{t12}{t18}</div>;
    $[41] = t12;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t10 || $[45] !== t19 || $[46] !== t9) {
    t20 = <Dialog.Content className="w-[520px] max-w-[95vw]"><div className="flex w-full flex-col gap-4 p-6">{t9}{t10}{t19}</div></Dialog.Content>;
    $[44] = t10;
    $[45] = t19;
    $[46] = t9;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== onOpenChange || $[49] !== open || $[50] !== t20) {
    t21 = <Dialog open={open} onOpenChange={onOpenChange}>{t20}</Dialog>;
    $[48] = onOpenChange;
    $[49] = open;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  return t21;
}
function _temp3(item_1) {
  return !item_1.jaExiste;
}
function _temp2(item_0) {
  return item_0.data;
}
function _temp(item) {
  return !item.jaExiste;
}